import React from 'react';
import { Typography } from './Typography';
import { InstagramIcon, TwitterIcon, FacebookIcon } from 'lucide-react';
import { t } from '../src/locales';
export const Footer = () => {
  return <footer className="w-full bg-[#192636] py-12 px-6 md:px-12" data-id="element-50">
      <div className="max-w-6xl mx-auto" data-id="element-51">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10" data-id="element-52">
          <div data-id="element-53">
            <Typography variant="large" as="h3" className="text-white mb-4 font-[200]" data-id="element-54">
              {t('navbar.logo')}
            </Typography>
            <Typography variant="small" className="text-white/70" data-id="element-55">
              {t('footer.description')}
            </Typography>
            <div className="flex space-x-4 mt-4" data-id="element-56">
              <a href="#" className="text-white/70 hover:text-white" data-id="element-57">
                <InstagramIcon size={20} data-id="element-58" />
              </a>
              <a href="#" className="text-white/70 hover:text-white" data-id="element-59">
                <TwitterIcon size={20} data-id="element-60" />
              </a>
              <a href="#" className="text-white/70 hover:text-white" data-id="element-61">
                <FacebookIcon size={20} data-id="element-62" />
              </a>
            </div>
          </div>
          <div data-id="element-63">
            <Typography variant="medium" as="h4" className="text-white mb-4 font-[200]" data-id="element-64">
              {t('footer.product.title')}
            </Typography>
            <ul className="space-y-2" data-id="element-65">
              {t('footer.product.links').map((link, index) => <li key={index} data-id="element-66">
                  <a href="#" className="text-white/70 hover:text-white text-sm" data-id="element-67">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>
          <div data-id="element-68">
            <Typography variant="medium" as="h4" className="text-white mb-4 font-[200]" data-id="element-69">
              {t('footer.resources.title')}
            </Typography>
            <ul className="space-y-2" data-id="element-70">
              {t('footer.resources.links').map((link, index) => <li key={index} data-id="element-71">
                  <a href="#" className="text-white/70 hover:text-white text-sm" data-id="element-72">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>
          <div data-id="element-73">
            <Typography variant="medium" as="h4" className="text-white mb-4 font-[200]" data-id="element-74">
              {t('footer.company.title')}
            </Typography>
            <ul className="space-y-2" data-id="element-75">
              {t('footer.company.links').map((link, index) => <li key={index} data-id="element-76">
                  <a href="#" className="text-white/70 hover:text-white text-sm" data-id="element-77">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col md:flex-row justify-between items-center" data-id="element-78">
          <Typography variant="small" className="text-white/50 mb-4 md:mb-0" data-id="element-79">
            {t('footer.copyright')}
          </Typography>
          <div className="flex space-x-6" data-id="element-80">
            {t('footer.legal').map((item, index) => <a key={index} href="#" className="text-white/50 hover:text-white text-xs" data-id="element-81">
                {item}
              </a>)}
          </div>
        </div>
      </div>
    </footer>;
};